module.exports = __webpack_public_path__ + "img/close.0a85ddde.svg";